import { memo } from "react";

import { motion, AnimatePresence } from "motion/react";

import { Spinner } from "../spinner";

export const Preloader = memo(function Preloader({
  isLoading,
}: {
  isLoading: boolean;
}) {
  return (
    <AnimatePresence>
      {isLoading && (
        <motion.div
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
          className="fixed inset-0 z-[9999] flex items-center justify-center bg-white dark:bg-stone-950"
        >
          <Spinner className="animate-spin text-black dark:text-white" />
        </motion.div>
      )}
    </AnimatePresence>
  );
});
